"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = void 0;
var baseRoute = '/package-service/v1/package';
exports.Routes = {
    GET: "".concat(baseRoute),
    GET_ALL_TASK_PACKAGES: "".concat(baseRoute, "/getAllTaskPackages"),
    UPSERT: "".concat(baseRoute, "/upsert")
};
//# sourceMappingURL=Package.consts.js.map